"use strict";

angular.module('app.factories.info', [])

// -------------------------------------------//
//               f_Info is for Popups
// -------------------------------------------//

.factory('f_Info', ['$rootScope',
    function ($rootScope) {

        var obj = {
            errors: [],
            // -------------------------------------------//
            //               Add new Info
            // -------------------------------------------//
            addInfo: function (e) {
                    if($rootScope.surpressErrors){ return ; }
                   for(var i = 0; i < obj.errors.length; i++)
                    {
                      //  console.log('addInfo');
                        if(obj.errors[i].Type === e.Type )
                            //&& e.Code === obj.errors[i].Code)
                        {
                            console.log(obj.errors[i]);
                            return;
                        }
                    }
                    obj.errors.push(e);


                $rootScope.$broadcast('Info');
              //  console.log('addInfo3');
            },
            // -------------------------------------------//
            //               Get the next Info
            // -------------------------------------------//
            getNextInfo: function () {
              //  console.log('f_info getNextInfo');
                var e = obj.errors.pop();
                return e;
            },
            add: function (title, text) {
                var e = {
                    "Title": title,
                    "DisplayText": text
                };
                obj.addInfo(e);
            },
            closeInfo: function () {

            },
            setCallbackAfterLastInfo: function (c) {
                obj.CallbackAfterLastInfo = c;
                return obj;
            },
            getCallbackAfterLastInfo: function () {
                return obj.CallbackAfterLastInfo;
            }

        };

        return obj;

    }
]);
